// extracted by mini-css-extract-plugin
export default {"recos":"s4-z","productCardOverride":"t4-z","rowHasBadge":"u4-z"};